var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"q10__page my-14"},[_c('div',{staticClass:"container px-11 2xl:px-3 m-auto"},[_c('div',{staticClass:"q10__article_container__title_head m-4"},[_c('article-title-tour',{attrs:{"options":{
                    tourtitle: _vm.currentPage.content.tourtitle.text,
                    titlecolor: 'text-flamingo',
                    toursubtitle: _vm.currentPage.content.toursubtitle.text,
                    subtitlecolor: 'text-nandor',
                }}})],1),_c('div',{staticClass:"container-components"},[_c('div',{staticClass:"card break-inside-avoid"},[_c('hotspot-richmedia',{staticClass:"top-3 md:top-3 -right-2",attrs:{"options":{
                        icon: 'diaporama',
                        collection: _vm.getRichmediaByCollection(
                            _vm.currentPage,
                            'Création de la mission Maitrise des Risques en 2011'
                        ),
                    }}})],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('div',{staticClass:"relative top-0 left-0 w-full"},[_c('image-with-descriptions',{staticClass:"mt-1 mb-1",attrs:{"options":{
                            image300:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.image2.src,
                            descriptions: [
                                {
                                    text: _vm.currentPage.images.image2.edf,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                    fontSize: 'text-xs md:text-base',
                                } ],
                        }}})],1),_c('div',{staticClass:"absolute top-0 left-0 p-7 xl:p-3 2xl:p-7"},[_c('TimelineTitle',{attrs:{"options":{
                            year: _vm.currentPage.content.secondYear.text,
                            pretitle:
                                _vm.currentPage.content.secondPretitle.text,
                            title: _vm.currentPage.content.secondTitle.text,
                            content: _vm.currentPage.content.secondContent.text,
                            fontSize: {},
                            color: {
                                year: 'text-yellow-500',
                                pretitle: 'text-white',
                                title: 'text-white',
                                content: 'text-white',
                            },
                        }}})],1)]),_c('div',{staticClass:"card break-inside-avoid"},[_c('hotspot-richmedia',{staticClass:"top-9 -right-2 md:top-5 lg:top-5",attrs:{"options":{
                        icon: 'diaporama',
                        collection: _vm.getRichmediaByCollection(
                            _vm.currentPage,
                            'Projet performance, Hydreole, numero spécial, decembre 2014'
                        ),
                    }}}),_c('TimelineTitle',{attrs:{"options":{
                        year: _vm.currentPage.content.thirdYear.text,
                        pretitle: _vm.currentPage.content.thirdPretitle.text,
                        title: _vm.currentPage.content.thirdTitle.text,
                        content: _vm.currentPage.content.thirdContent.text,

                        fontSize: {
                            pretitle: 'text-base 2xl:text-4xl',
                            title: 'text-3xl 2xl:text-4xl',
                        },
                        color: {
                            title: 'text-flamingo',
                        },
                    }}})],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('TimelineTitle',{attrs:{"options":{
                        year: _vm.currentPage.content.fourthYear.text,
                        pretitle: _vm.currentPage.content.fourthpPetitle.text,
                        title: _vm.currentPage.content.fourthTitle.text,
                        content: _vm.currentPage.content.fourthContent.text,

                        fontSize: {
                            pretitle: 'text-2xl 2xl:text-4xl',
                            title: 'text-3xl 2xl:text-4xl',
                        },
                        color: {
                            title: 'text-flamingo',
                        },
                    }},scopedSlots:_vm._u([{key:"bottom",fn:function(){return [_c('image-with-descriptions',{staticClass:"mt-1 mb-1",attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.image3.src,
                            }}}),_c('span',{staticClass:"q10__copyright",domProps:{"innerHTML":_vm._s(_vm.currentPage.images.image3.text)}})]},proxy:true}])})],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('TimelineTitle',{attrs:{"options":{
                        year: _vm.currentPage.content.fifthYear.text,
                        pretitle: _vm.currentPage.content.fifthPretitle.text,
                        title: _vm.currentPage.content.fifthTitle.text,
                        content: _vm.currentPage.content.fifthContent.text,

                        fontSize: {
                            pretitle: 'text-base 2xl:text-lg',
                            title: 'text-3xl 2xl:text-3xl',
                        },
                        color: {
                            title: 'text-flamingo',
                        },
                    }}},[_c('div',{staticClass:"relative w-full h-full"},[_c('image-with-descriptions',{staticClass:"mt-1 mb-1",attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.image4.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.image4
                                            .text,
                                        position: 'top-left', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                        fontSize: 'text-xs md:text-base',
                                    },
                                    {
                                        text: _vm.currentPage.images.image4.alt,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                        fontSize: 'text-xs md:text-base',
                                    } ],
                            }}}),_c('div',{staticClass:"\n                                absolute\n                                top-8\n                                md:top-10\n                                right-0\n                                p-2\n                                text-right\n                            "},[_c('paragraph',{staticClass:"paragrafSchimbat",attrs:{"options":{
                                    color: 'text-white',
                                }}})],1)],1)])],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('div',{staticClass:"relative"},[_c('hotspot-richmedia',{staticClass:"top-3 lg:top-5 -right-2",attrs:{"options":{
                        icon: 'diaporama',
                        collection: _vm.getRichmediaByCollection(
                            _vm.currentPage,
                                'Souvenirs des challenges de linnovation'
                            ),
                        }}})],1),_c('TimelineTitle',{attrs:{"options":{
                        year: _vm.currentPage.content.sixthYear.text,
                        pretitle: _vm.currentPage.content.sixthPretitle.text,
                        title: _vm.currentPage.content.sixthTitle.text,

                        fontSize: {
                            pretitle: 'text-sm 2xl:text-lg',
                            title: 'text-2xl 2xl:text-3xl',
                        },
                        color: {
                            title: 'text-flamingo',
                        },
                    }},scopedSlots:_vm._u([{key:"top",fn:function(){return [_c('image-with-descriptions',{staticClass:"mt-1 mb-1",attrs:{"options":{
                            image:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.image5.src,
                            descriptions: [
                                {
                                    text: _vm.currentPage.images.image5.text,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                    fontSize: 'text-xs md:text-base',
                                } ],
                        }}})]},proxy:true}])},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sixthContent.text)}})])],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('hotspot-richmedia',{staticClass:"top-20 -right-2 md:top-3 lg:top-5 xl:top-2 2xl:top-5",attrs:{"options":{
                        icon: 'diaporama',
                        collection: _vm.getRichmediaByCollection(
                            _vm.currentPage,
                            'Évolution des résultats sécurité'
                        ),
                    }}}),_c('TimelineTitle',{attrs:{"options":{
                        year: _vm.currentPage.content.seventhYear.text,
                        pretitle: _vm.currentPage.content.seventhPretitle.text,
                        title: _vm.currentPage.content.seventhTitle.text,
                        content: _vm.currentPage.content.seventhContent.text,

                        fontSize: {
                            pretitle: 'text-base 2xl:text-lg',
                            title: 'text-3xl 2xl:text-3xl',
                        },
                        color: {
                            title: 'text-flamingo',
                        },
                    }},scopedSlots:_vm._u([{key:"bottom",fn:function(){return [_c('image-with-descriptions',{staticClass:"mt-1 mb-1",attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.image6.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.image6
                                            .text,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'vertical', // vertical, horizontal
                                        color: 'text-nandor',
                                        fontSize: 'text-xs md:text-base',
                                    } ],
                            }}})]},proxy:true}])})],1)])]),_c('timeline-carousel',{attrs:{"options":{
            timeline: _vm.currentPage.timeline,
        }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }